import initJobDetails from '~/jobs';

document.addEventListener('DOMContentLoaded', initJobDetails);
